import {
  AssetDetails,
  BaseAssetManagerContextState,
} from 'modules/assetManager/contexts/BaseAssetManagerContext';
import { MessageType } from 'modules/graphql';
import { SmsSender } from 'modules/sendingPlatforms/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { BaseAsset } from 'modules/assetManager/types';
import { SmsSmartOptInLink } from '../types';

export type SmsSmartOptInContextState = BaseAssetManagerContextState<SmsSmartOptInLink> & {
  assets: BaseAsset[];
  smsSenders: SmsSender[];
  messageTypes: MessageType[];
  assetTypeName?: string;
  isModalOpen: boolean;
  isEditing: boolean;
  changesMade: boolean;
  selectedAssetId?: string | number;
  assetDetails: AssetDetails<BaseAsset>;
  assetErrors: any;
  onSearch: (searchText: string) => void;
  setIsModalOpen: (isOpen: boolean) => void;
  setIsEditing: (editing: boolean) => void;
  setChangesMade: (changesMade: boolean) => void;
  selectAssetInList: (selected: BaseAsset) => void;
  handleClose: (onClose: () => void) => void;
  createNew: () => void;
  save: (transformToInput?: ((assetDetails: AssetDetails<BaseAsset>) => any) | undefined) => void;
  cancel: () => void;
  updateAssetDetails: (updated: AssetDetails<BaseAsset>) => void;
  updateAssetErrors: (errors: any) => void;
};

export const SMS_SMART_OPT_IN_CONTEXT_STATE = {
  assets: [],
  smsSenders: [],
  messageTypes: [],
  assetTypeName: undefined,
  isModalOpen: false,
  isEditing: false,
  changesMade: false,
  selectedAssetId: undefined,
  assetDetails: {},
  assetErrors: {},
  onSearch: noop,
  setIsModalOpen: noop,
  setIsEditing: noop,
  setChangesMade: noop,
  selectAssetInList: noop,
  handleClose: noop,
  createNew: noop,
  save: noop,
  cancel: noop,
  updateAssetDetails: noop,
  updateAssetErrors: noop,
  deleteAsset: noop,
};

export const SmsSmartOptInContext = createContext<SmsSmartOptInContextState>(
  SMS_SMART_OPT_IN_CONTEXT_STATE,
);

export const useSmsSmartOptInContext = () => useContext(SmsSmartOptInContext);
